import React from "react";
import useWidth from "../../hooks/useWidth";
import MobileHeader from "../../layout/MobileHeader";
import headerImg from "../../assets/images/topLocationHeader.png";
import cardImg from "../../assets/images/loctionimg.png";
import Icon from "../../components/Icon";
import { faAngleLeft, faAngleRight } from "@fortawesome/free-solid-svg-icons";
import AccommodationCard from "../../components/cards/mobileView/AccommodationCard";
import OfferCard from "../../components/cards/OfferCard";
import Navbar from "../../layout/Navbar";


import MobileHeaderSearch from "../../components/MobileHeaderSearch";

const TopLocation = () => {
  const width = useWidth();
  return (
    <>
      {width > 992 ? (
        <>
        <Navbar gradient={true}/>
          <h1 style={{marginTop:"300px"}}>This page available on in Mobile</h1>
        </>
      ) : (
        <>
          <MobileHeader height='237px' >

            <MobileHeaderSearch placeholder="Top locations"/>

          </MobileHeader>
          <section className="px-4" style={{ marginTop: "270px" }}>
            <div className="">
              <p className="top-heading">Most visited places in 2024</p>

              <div className="row p-0 m-0">
                {Array(10)
                  .fill()
                  .map(() => (
                    <div className="col-6 p-1">
                      <div
                        className=""
                        style={{ height: "121px", position: "relative" }}
                      >
                        <img
                          src={cardImg}
                          className="w-100 h-100 rounded "
                          alt=""
                          style={{ objectFit: "cover" }}
                        />
                        <div
                          className="w-100 h-100 rounded d-flex justify-content-center align-items-center flex-column"
                          style={{
                            position: "absolute",
                            top: "0",
                            background:
                              "linear-gradient(to left, rgba(0, 0, 0, 0.47), rgba(0, 0, 0, 0.47)),linear-gradient(to left, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2))",
                          }}
                        >
                          <p
                            className="mb-0 text-center text-light"
                            style={{ color: "#fffff", fontSize: "24px" }}
                          >
                            Shiva Temple
                          </p>
                          <p className="fs-9 mb-1 text-light">Pokhara, Nepal</p>
                          <div className="text-warning me-2 fs-9 d-flex">
                            <i className="bi bi-star-fill"></i>
                            <i className="bi bi-star-fill"></i>
                            <i className="bi bi-star-fill"></i>
                            <i className="bi bi-star-fill"></i>
                            <i className="bi bi-star-half"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
              </div>

              <div className="w-100 my-2 d-flex justify-content-center align-items-center px-5">
                <ul className="list-unstyled d-flex gap-2 align-items-center">
                  <li style={{ fontSize: "30px", color: "#939393" }}>
                    <Icon icon={faAngleLeft} />
                  </li>
                  <li>
                    <div
                      className="d-flex justify-content-center align-items-center"
                      style={{
                        width: "30px",
                        height: "30px",
                        border: "2px solid #939393",
                        borderRadius: "50%",
                        color: "#939393",
                      }}
                    >
                      1
                    </div>
                  </li>
                  <li>
                    <div
                      className="d-flex justify-content-center align-items-center"
                      style={{
                        width: "30px",
                        height: "30px",
                        border: "2px solid #939393",
                        borderRadius: "50%",
                        color: "#939393",
                      }}
                    >
                      2
                    </div>
                  </li>
                  <li>
                    <div
                      className="d-flex justify-content-center align-items-center"
                      style={{
                        width: "30px",
                        height: "30px",
                        border: "2px solid #939393",
                        borderRadius: "50%",
                        color: "#939393",
                      }}
                    >
                      3
                    </div>
                  </li>
                  <li>
                    <div
                      className="d-flex justify-content-center align-items-center"
                      style={{
                        width: "30px",
                        height: "30px",
                        border: "2px solid #939393",
                        borderRadius: "50%",
                        color: "#939393",
                      }}
                    >
                      4
                    </div>
                  </li>
                  <li>
                    <div
                      className="d-flex justify-content-center align-items-center "
                      style={{
                        width: "30px",
                        height: "30px",
                        border: "2px solid #939393",
                        borderRadius: "50%",
                        color: "#939393",
                      }}
                    >
                      ...
                    </div>
                  </li>
                  <li style={{ fontSize: "30px", color: "#939393" }}>
                    <Icon icon={faAngleRight} />
                  </li>
                </ul>
              </div>
            </div>

            <hr />
          </section>
          <div className="ps-3">
            <div className="top-heading">Location based Accommodation </div>

            <div className="mt-4 p-0">
              <ul className="list-unstyled d-flex overflow-auto scrollbar-hidden">
                {Array(10)
                  .fill()
                  .map((location, i) => (
                    <li className="m-2" key={i}>
                      <div
                        className=""
                        style={{ width: "230px", height: "240px" }}
                      >
                        <AccommodationCard />
                      </div>
                    </li>
                  ))}
              </ul>
            </div>
          </div>
          <div className="d-flex justify-content-center align-item-center">
            <button className="secondary-btn "> Explore more </button>
          </div>

          {/* offers */}
          <div className="offers mt-4">
            <div className="row mx-0 ">
                <div className="top-heading ps-3">Offers Tailored For You</div>
              
            </div>

            <div className="row  mx-0 my-3">
              <ul className="list-unstyled d-flex offers-card-list-mobile  mobileScrollBar">
                <li className="m-2">
                  <div className="bg-dark rounded offers-card-container">
                    <OfferCard
                      data={"Get upto 15% off on your First Booking"}
                    />
                  </div>
                </li>

                <li className="m-2">
                  <div className="bg-dark rounded offers-card-container">
                    <OfferCard data={"Budget Friendly Homestays"} />
                  </div>
                </li>
              </ul>

              <div className="col-md-6 d-flex justify-content-start sm-justify-content-end"></div>
            </div>
            <div className="d-flex justify-content-center align-item-center">
            <button className="secondary-btn "> Explore more </button>
          </div>
          </div>
        </>
      )}
    </>
  );
};

export default TopLocation;
